import type { TFunction } from 'i18next';

// Campaign-list density (#162). Pure so the persisted-value coercion is
// testable without mounting the list.
//
// The redesign shipped a card-only feed: every row carries a rendered WhatsApp
// message preview, so a customer with 522 campaigns gets ~3 rows per screen —
// ~170 screens to scan their history. Worse, when someone's campaigns share a
// name and differ only by audience, the card spends its space on the one thing
// that does NOT vary (the same image every time) and compresses the things that
// do: audience, time, recipient count. The compact row inverts that.

export type CampaignViewMode = 'cards' | 'rows';

// Type-only import; see `campaign-list-sort.ts`.

/**
 * The density toggle's label, in the reader's language. Was module-level English
 * baked at import time — see `campaignSortLabel` for the full note. `t` is
 * REQUIRED so the compiler finds every call site.
 */
export function campaignViewLabel(t: TFunction, mode: CampaignViewMode): string {
  return mode === 'rows'
    ? t('campaignsRedesign.viewList', 'List')
    : t('campaignsRedesign.viewCards', 'Cards');
}

/** Cards stay the default so nobody's list silently changes shape on upgrade. */
export const DEFAULT_CAMPAIGN_VIEW: CampaignViewMode = 'cards';

/** Narrow an unknown (e.g. localStorage) value to a valid view mode. */
export function coerceCampaignView(value: unknown): CampaignViewMode {
  return value === 'rows' || value === 'cards' ? value : DEFAULT_CAMPAIGN_VIEW;
}
